  import React from "react";

  const FloatingSocial = () => {
  return (
    <div>

  {/* Floating Social */}
      <div className="floating-social">
        <a href="https://www.facebook.com/hotelpahadi" target="_blank" rel="noopener noreferrer" className="fb">
          <i className="fa fa-facebook"></i>
        </a>
        <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="tw">
          <i className="fa fa-twitter"></i>
        </a>
        <a href="https://www.instagram.com/hotel_pahadi/" target="_blank" rel="noopener noreferrer" className="ig">
          <i className="fa fa-instagram"></i>
        </a>
        <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="yt">
          <i className="fa fa-youtube-play"></i>
        </a>
        <a href="https://wa.me/919000000000" target="_blank" rel="noopener noreferrer" className="wa">
          <i className="fa fa-whatsapp"></i>
        </a>
      </div>
      </div>

  );
};

export default FloatingSocial;